const userId = user => user?.user_id ?? user?.id ?? user?.value;
const compareText = (left, right) => String(left || '').localeCompare(String(right || ''), 'vi', {
    sensitivity: 'base',
});

export const userDisplayName = user => {
    if (!user) return '';
    if (user.display_name) return user.display_name;

    const roleName = user.user_role?.name || user.role_name;
    return [roleName, user.full_name].filter(Boolean).join(' - ');
};

const userSortInfo = (user, label) => {
    const separatorIndex = String(label || '').indexOf(' - ');
    const roleNameFromLabel = separatorIndex >= 0 ? label.slice(0, separatorIndex) : '';
    const fullNameFromLabel = separatorIndex >= 0 ? label.slice(separatorIndex + 3) : label || '';

    return {
        roleName: user?.user_role?.name || user?.role_name || roleNameFromLabel,
        fullName: user?.full_name || fullNameFromLabel,
    };
};

// Giữ nguyên value của catalog; chỉ chuẩn hóa label và sắp xếp Role A-Z, rồi tên nhân viên A-Z.
export const mapUserOptionLabels = (options = [], users = [], optionValue = 'value') => {
    const userMap = new Map(users.map(user => [String(userId(user)), user]));

    return options.map((option, index) => {
        const user = userMap.get(String(option?.[optionValue]));
        const label = userDisplayName(user) || userDisplayName(option) || option.label;
        const sortInfo = userSortInfo(user || option, label);

        return { option: { ...option, label }, sortInfo, index };
    }).sort((left, right) => {
        // Option không có role được xếp sau các option có role hiển thị.
        if (!left.sortInfo.roleName && right.sortInfo.roleName) return 1;
        if (left.sortInfo.roleName && !right.sortInfo.roleName) return -1;

        return compareText(left.sortInfo.roleName, right.sortInfo.roleName)
            || compareText(left.sortInfo.fullName, right.sortInfo.fullName)
            || left.index - right.index;
    }).map(item => item.option);
};
